import { Controller } from "@hotwired/stimulus";
import { get, post, put } from '@rails/request.js'

// Filters .list-item elements in .clip_cells based on #customers-filter and #address-filter dropdowns
export default class extends Controller {
  static targets = ["listItem", "customersFilter", "addressFilter"];

  connect() {
    // get filter values from URL parameters
    const url = new URL(window.location.href);
    const customerValue = url.searchParams.get('customer');
    const addressValue = url.searchParams.get('address');
    const transferId = url.searchParams.get('transfer_id');
    if (transferId) {
      const selectedTransfer = this.listItemTargets.find(item => item.dataset.id === transferId);
      if (selectedTransfer) {
        selectedTransfer.querySelector('.a-item-toggle').scrollIntoView(true);
        selectedTransfer.querySelector('.a-item-toggle').click();
      }
    }
    this.customersFilterTarget.value = customerValue || '';
    this.addressFilterTarget.value = addressValue || '';
    this.filter();
  }

  toggleDetails(event) {
    const listItem = event.currentTarget.closest('.list-item');
    const listItemLine = listItem.querySelector('.a-item-toggle');
    const transferDetails = listItem.querySelector('.apartment-transfer-details');
    const transferId = listItem.dataset.id;
    const transferDetailsContainer = listItem.querySelector(`#apartment-transfer-${transferId}-details`);
    if (transferDetailsContainer) {
      const url = new URL(window.location.href);
      url.searchParams.set('transfer_id', transferId);
      window.history.replaceState({}, '', url.toString());

      transferDetailsContainer.innerHTML = "Lataetaan tietoja...";
      const display = transferDetails.style.display === 'none' ? 'block' : 'none';
      transferDetails.style.display = display;
      if (display === 'block') {
        get(`/admin/transfers/${listItem.dataset.id}/details`, {
          headers: {
            'Accept': 'text/vnd.turbo-stream.html'
          }
        }).catch(_error => {
          transferDetails.innerHTML = "Error loading details: ";
        });
        listItemLine.classList.add('a-transfer-item-open');
        listItem.classList.add('apartment-transfer-open');
      } else {
        listItemLine.classList.remove('a-transfer-item-open');
        listItem.classList.remove('apartment-transfer-open');
      }
    }
  }

  filter() {
    const customerValue = this.customersFilterTarget.value;
    const addressValue = this.addressFilterTarget.value;


    // Add filters to urls
    const url = new URL(window.location.href);
    if (customerValue) {
      url.searchParams.set('customer', customerValue);
    } else {
      url.searchParams.delete('customer');
    }
    if (addressValue) {
      url.searchParams.set('address', addressValue);
    } else {
      url.searchParams.delete('address');
    }
    window.history.replaceState({}, '', url.toString());

    this.listItemTargets.forEach(item => {
      const itemCustomers = item.dataset.customers.split(',');
      const itemAddress = item.dataset.address;
      const customerMatch = !customerValue || itemCustomers.includes(customerValue);
      const addressMatch = !addressValue || itemAddress === addressValue;
      if (customerMatch && addressMatch) {
        item.style.display = "";
      } else {
        item.style.display = "none";
      }
    });
  }

  updateKey(event) {
    const keyData = event.currentTarget.closest('.key-data');
    const keyId = keyData.dataset.keyId;
    const leaseId = keyData.dataset.leaseId;
    const movingType  = keyData.dataset.movingType;

    if (!keyId || !leaseId) return;

    let keyState = null;
    if (movingType === 'moving_in') {
      keyState = event.currentTarget.checked ? 'received' : 'not_received';
    } else if (movingType === 'moving_out') {
      keyState = event.currentTarget.checked ? 'returned' : 'received';
    }

    event.currentTarget.disabled = true; // Disable the checkbox to prevent multiple submissions

    put(`/admin/leases/${leaseId}/keys/${keyId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({ lease_key: { state: keyState } })
    }).catch(error => {
      alert("Error updating key state: " + error.message);
    });
  }

  addKey(event) {
    const leaseId = event.currentTarget.dataset.leaseId;
    const movingType = event.currentTarget.dataset.movingType;
    const stamp = event.currentTarget.value;

    if (!leaseId || !movingType || !stamp) return;

    let selected = null;
    if (movingType == 'moving_out') {
      selected = 'true'
    }

    event.currentTarget.disabled = true; // Disable the input to prevent multiple submissions

    post(`/admin/leases/${leaseId}/keys`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({new_key: { stamp: stamp, selected: selected }})
    }).finally(() => {
      event.target.disabled = false; // Re-enable the input after submission
      event.target.value = ''; // Clear the input field after submission
    }).catch(error => {
      alert("Error creating key: " + error.message);
    });
  }
}
